export const parametriESimRadioButtons = [
    {text: "Numero di telefono", value: "numeroDiTelefono"},
    {text: "Numero seriale", value: "numeroSeriale"},
]

export const parametriESimFilter = {
    numeroDiTelefono: {
        label: "Numero di Telefono",
        value: "",
    },
    numeroSeriale: {
        label: "Numero Seriale",
        value: "",
    },
    statoSim: {
        label: 'Stato SIM',
        value: ""
    },
    esitoInvio: {
        label: 'Esito invio',
        value: ""
    }
}

export const sortingCriteria = [
    {text: "Numero di telefono", value: "msisdn"},
    {text: "N. Seriale", value: "iccId"},
    {text: "Stato eSIM", value: "statoSim"},
    {text: "Data invio", value: "dataInvio"},
    {text: "email Inviata", value: "qrcodeSent"},
];